import { ReactNode } from 'react';
import Avnish_Kumar_Resume from '../Resume/Avnish_Kumar_Resume.pdf'
import {
  Box,
  Flex,
  HStack,
  IconButton,
 useDisclosure,
  useColorModeValue,
  Stack,
  Heading,
 
} from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
import { Link } from 'react-scroll';
// const Links = ['Skills', 'Project', 'Contact'];

const NavLink = ({ children }) => (
  <Link
    px={2}
    py={1}
    rounded={'md'}
    _hover={{
      textDecoration: 'none',
      bg: useColorModeValue('gray.200', 'gray.700'),
    }}
    href={'#'}>
    {children}
  </Link>
);

export default function Simple() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Box bg={useColorModeValue('#DC143C', '#DC143C')}
        px={4} zIndex='999'
         position="fixed" 
         scrollBehavior={"smooth"}
         top={'0'}         
         transition={"all 0.3s ease"}  w='100%'>
        <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
          <IconButton
            size={'md'}
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon color={"black"} fontSize={"30px"}/>}
            aria-label={'Open Menu'}
            display={{ md: 'none',}}
            onClick={isOpen ? onClose : onOpen}
          />
           {/* <Flex alignItems={'right'}> */}
             <Box rounded={"100%"}  ml={{md:"5",base:"200"}} padding={'1'} border={'5px solid white'}><Heading as ='h1' >AK</Heading></Box>
          {/* </Flex> */}
          <HStack spacing={8} alignItems={'center'}>
            {/* <Box>Logo</Box> */}
            <HStack
              as={'nav'}
              spacing={4}
              _hover={{cursor:'pointer'}}
              display={{ base: 'none', md: 'flex'}}>
              
         
            <Link to='home'>
                <Heading as='h4' size='md' color={'#EEEEEE'} smoth={true} duration={1000} >Home</Heading>
              </Link>
              <Link  to='About'>
              <Heading as='h4' size='md'color={"#EEEEEE"} smoth={true} duration={2000}>About</Heading>
              </Link>
              <Link  to='Skills'>
              <Heading as='h4' size='md' color={"#EEEEEE"} smoth={true} duration={2000}>Skill</Heading>
              </Link>
              <Link  to='Project'>
              <Heading as='h4' size='md' color={"#EEEEEE"} smoth={true} duration={2000}>Project</Heading>
              </Link>
            
             
              <Link  to='Github'>
              <Heading as='h4' size='md' color={"#EEEEEE"} smoth={true} duration={1000}>Github</Heading>
              </Link>
              <Link  to='Contact'>
              <Heading as='h4' size='md' color={"#EEEEEE"} smoth={true} duration={1000}>Contact</Heading>
              </Link>
              {/* <Link  > */}
              <Heading as='h4' size='md' color={"#EEEEEE"} smoth={true} duration={1000}>
              <a  href={Avnish_Kumar_Resume} download={'Avnish_Kumar_Resume'}>
              <p onClick={()=>{window.open("https://drive.google.com/file/d/17EazqHpb5BhbDUPezOZv2RYWJUV5zHzj/view?usp=sharing","_blank")}}>Resume</p>
              </a>
              </Heading>
              {/* </Link> */}
            
 
            </HStack>
          </HStack>
         
        </Flex>

        {isOpen ?  (
          <Box pb={4} display={{ md: 'none' }}  >
            <Stack as={'nav'} spacing={4}   >
            
              <Link to='home' >
                <Heading as='h4' size='md' color={'#000'} smoth={true} duration={2000} onClick={ onClose }>Home</Heading>
              </Link>
              <Link  to='About'>
              <Heading as='h4' size='md' color={'#000'} smoth={true} duration={2000} onClick={ onClose }>About</Heading>
              </Link>
              <Link  to='Skills'>
              <Heading as='h4' size='md' color={'#000'} smoth={true} duration={2000} onClick={ onClose }>Skill</Heading>
              </Link>
              <Link  to='Project'>
              <Heading as='h4' size='md' color={'#000'} smoth={true} duration={2000} onClick={ onClose }>Project</Heading>
              </Link>
                    
              <Link  to='Github'>
              <Heading as='h4' size='md' color={'#000'} smoth={true} duration={3000} onClick={ onClose }>Github</Heading>
              </Link>
              <Link  to='Contact'>
              <Heading as='h4' size='md' color={'#000'} smoth={true} duration={2000} onClick={ onClose }>Contact</Heading>
              </Link>
              <Heading as='h4' size='md' color={'#000'} smoth={true} duration={1000} onClick={ onClose }>
              <a  href={Avnish_Kumar_Resume} download={'Avnish_Kumar_Resume'}>
              <p onClick={()=>{window.open("https://drive.google.com/file/d/17EazqHpb5BhbDUPezOZv2RYWJUV5zHzj/view?usp=sharing","_blank")}}>Resume</p>
              </a>
              </Heading>
              
            </Stack>
           
 
          </Box>
        ) :null}
      </Box>

      {/* <Box p={4}>Main Content Here</Box> */}
    </>
  );
}